import { Component, Input } from '@angular/core';
import { MartOrderDetailsComponent } from 'app/mart';

@Component({
    selector: 'mart-order-details-info-tab',
    templateUrl: './mart-order-details-info-tab.component.html',
    styleUrls: [
        './mart-order-details-info-tab.component.scss',
        '../mart-order-details.component.scss'
    ]
})
export class MartOrderDetailsInfoTabComponent {
    @Input()
    public parent!: MartOrderDetailsComponent;
}
